<template>
  <div>
    <list
      row-key="UserId"
      ref="list"
      unit="记录"
      :expand-all-row="true"
      :page="page"
      :query-params="params"
      :show-checkbox="showCheckbox"
      :show-query="true"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="节假日名称">
          <el-input size="mini" v-model="params.HolidayName" placeholder="请填写节假日名称"></el-input>
        </el-form-item>
        <el-form-item label="年份">
          <el-date-picker
            v-model="params.Year"
            type="year"
            size="mini"
            value-format="yyyy"
            placeholder="请选择年份">
          </el-date-picker>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="HolidayName" label="节假日名称" :min-width="isMB?100:''" />
        <el-table-column prop="StartDate" label="开始日期" :min-width="isMB?120:''">
          <template slot-scope="{row}">
            <span>{{$commonJs.toDateString(row.StartDate)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="EndDate" label="结束日期" :min-width="isMB?120:''">
          <template slot-scope="{row}">
            <span>{{$commonJs.toDateString(row.EndDate)}}</span>
          </template>
        </el-table-column>
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    let date = new Date();
    return {
      api: require("@/api/ed/holiday").default,
      params: {
        HolidayName: "",
        Year: String(date.getFullYear()),
      },
      isMB: this.$store.state.isMB,
    };
  },
  methods: {
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error("删除失败，" + res.Msg);
        }
      });
    },
  },
};
</script>